import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isEmpty',
  standalone: true
})
export class IsEmptyPipe implements PipeTransform {

  transform(value: unknown): boolean {
    return value ? Object.keys(value).length === 0 : true;
  }

}
